import Swiper from "swiper";

import { Navigation, EffectFade, FreeMode, Keyboard } from "swiper/modules";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/keyboard";

class RelatedContent {
    constructor(element) {
        // Class properties.
        this.relatedMarkUp = element;

        this.nextBtn =
            this.relatedMarkUp.querySelector(".swiper-button-next") ?? false;

        this.prevBtn =
            this.relatedMarkUp.querySelector(".swiper-button-prev") ?? false;

        this.createCarousel();
    }

    createCarousel() {
        this.relContentCarousel = new Swiper(this.relatedMarkUp, {
            modules: [Navigation, Keyboard, FreeMode],
            speed: 1000,
            slidesPerView: 1, // Mobile.
            spaceBetween: 20,
            grabCursor: true,
            containerRole: `region`,
            navigation: {
                nextEl: this.nextBtn,
                prevEl: this.prevBtn,
            },
            breakpoints: {
                // Desktop.
                576: {
                    slidesPerView: 2, // show 2 items and 10% of the next one.,
                },
            },
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const relatedCarousels = document.querySelectorAll(
        `[data-carousel="related-content"]`,
    );

    if (relatedCarousels.length) {
        relatedCarousels.forEach((element) => {
            new RelatedContent(element);
        });
    }
});

export default RelatedContent;
